// Path calculation utilities for CompareMode

// Calculate distance between two points (in kilometers)
export const calculateDistance = (point1, point2) => {
  const R = 6371; // Earth's radius in kilometers
  const dLat = toRad(point2.latitude - point1.latitude);
  const dLon = toRad(point2.longitude - point1.longitude);
  const a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(toRad(point1.latitude)) * Math.cos(toRad(point2.latitude)) * 
    Math.sin(dLon/2) * Math.sin(dLon/2); 
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
  return R * c;
};

// Convert degrees to radians
export const toRad = (value) => {
  return value * Math.PI / 180;
};

// Calculate path details (total distance and segments)
export const calculatePathDetails = (path, locations) => {
  let totalDistance = 0;
  const segments = [];
  
  for (let i = 0; i < path.length - 1; i++) {
    const loc1 = locations.find(loc => loc.id === path[i]);
    const loc2 = locations.find(loc => loc.id === path[i + 1]);
    
    if (loc1 && loc2) {
      const distance = calculateDistance(loc1, loc2);
      totalDistance += distance;
      
      segments.push({
        from: loc1,
        to: loc2,
        distance: distance,
        fromIndex: i,
        toIndex: i + 1
      });
    }
  }
  
  return { distance: totalDistance, segments: segments };
};

// Format distance display
export const formatDistance = (distance) => {
  if (distance < 1) {
    return `${(distance * 1000).toFixed(0)}m`;
  }
  return `${distance.toFixed(2)}km`;
};

// Get formatted path name display
export const getPathName = (path, locations) => {
  if (!path || path.length === 0) return "Undefined Path";
  
  return path.map(id => {
    const loc = locations.find(l => l.id === id);
    return loc ? loc.name : id;
  }).join(" → ");
}; 